<ion-tabs >
  <ion-tab-bar class="header-background tab-bar"
    style="overflow-x: scroll; justify-content:center"
    *ngIf="dataSRV.settings['lockers']  && dataSRV.isAuthenticated.value == true"
    slot="bottom"
  >
    <ion-tab-button tab="home">
      <ion-icon [ngClass]="{ active: homeIsActive() }" name="home"></ion-icon>
      <ion-label [ngClass]="{ active: homeIsActive() }">
        {{
          ('keys.data.users_menu.home' | translate : {Default:'Home'}) || 'Home'
          }}</ion-label
      >
    </ion-tab-button>
    <ion-tab-button tab="vehicles">
      <ion-icon
        [ngClass]="{ active: vehiclesIsActive() }"
        name="car-sport"
      ></ion-icon>
      <ion-label [ngClass]="{ active: vehiclesIsActive() }">
        {{
          ('keys.data.users_menu.vehicles' | translate : {Default:'Vehicles'}) || 'Vehicles'
          }}</ion-label
      >
    </ion-tab-button>
    <ion-tab-button
      *ngIf="dataSRV['settings']['permits']['enabled'] == '1'"
      tab="permits"
    >
      <ion-icon
        [ngClass]="{ active: permitsIsActive() }"
        name="ticket"
      ></ion-icon>
      <ion-label [ngClass]="{ active: permitsIsActive() }">
     {{
          ('keys.data.users_menu.permits' | translate : {Default:'Permits'}) || 'Permits'
          }}</ion-label
      >
    </ion-tab-button>
    <ion-tab-button
      *ngIf="dataSRV['settings']['violations']['appeals_enabled'] == '1'"
      routerLink="/violations/appeals"
    >
      <ion-icon
        [ngClass]="{ active: appealsIsActive() }"
        name="information-circle"
      ></ion-icon>
      <ion-label [ngClass]="{ active: appealsIsActive() }">
        {{
          ('keys.data.users_menu.appeals' | translate : {Default:'Appeals'}) || 'Appeals'
          }}</ion-label
      >
    </ion-tab-button>
    <ion-tab-button
      *ngIf="dataSRV['settings']['lockers']['enabled'] == '1'"
      tab="lockers"
    >
      <ion-icon
        [ngClass]="{ active: lockersIsActive() }"
        name="lock-closed"
      ></ion-icon>
      <ion-label [ngClass]="{ active: lockersIsActive() }">
        {{
          ('keys.data.users_menu.lockers' | translate : {Default:'Lockers'}) || 'Lockers'
          }}</ion-label
      >
    </ion-tab-button>
  </ion-tab-bar>
</ion-tabs>
